module.exports = __webpack_public_path__ + "img/heart_3.8b3f3cb5.png";